import { tracking } from '@iwoca/frontend-tracking-library';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { DocumentRequirement } from 'components/Signup/TradingHistory/DocumentRequirement/DocumentRequirement';
import { TOfferDataRequirement } from 'lendingApi/lapiOverrides.types';
import { getAmplitudeDefaultEventProperties } from 'utils/amplitudeEvents';

type TProps = {
  isOptional: boolean;
  isSubmitted: boolean;
  status?: TOfferDataRequirement['actions'][number]['status'];
};

export const BwaSusaAnnual = ({ isOptional, isSubmitted, status }: TProps) => {
  return (
    <DocumentRequirement
      title={t`BWAs and SuSas from the last 2 years`}
      documentType="year end management and balance accounts"
      isOptional={isOptional}
      isSubmitted={isSubmitted}
      status={status}
    >
      <ul>
        <li>
          <Trans>
            BWAs and SuSas should be provided as a PDF, as a direct download
            from your <strong>accounting software</strong>
          </Trans>
        </li>
        <li>
          <Trans>
            BWAs should show company name, sales revenue, purchases of goods,
            costs including depreciation, interest expenses & preliminary
            results
          </Trans>
        </li>
        <li>
          <Trans>
            SuSas should include EB value, cumulative annual values & balance
            and be submitted in the correct format
          </Trans>
        </li>
        <li>
          <Trans>
            Accepted SuSa formats from DATEV:{' '}
            <strong>all posted accounts</strong> or{' '}
            <strong>general ledger accounts</strong>
          </Trans>
        </li>
        <li>
          <Trans>
            <strong>Tips</strong> for getting the SuSa upload right the first
            time can be found{' '}
            <a
              href="https://www.iwoca.de/kredit/datev-guide"
              target="_blank"
              rel="noreferrer"
              onClick={() =>
                tracking.ampli.ctaClick({
                  ...getAmplitudeDefaultEventProperties(),
                  'CTA text': 'SuSa support',
                })
              }
            >
              here
            </a>
          </Trans>
        </li>
      </ul>
    </DocumentRequirement>
  );
};
